import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);
    if (!sessionIdMatch) {
      navigate("/login", { replace: true });
      return;
    }

    const sessionId = sessionIdMatch[1];
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true });
        if (data.is_new) {
          // New user - needs profile completion
          navigate("/complete-profile", { replace: true, state: { user: data.user } });
        } else {
          await refreshUser();
          navigate("/dashboard", { replace: true });
        }
      } catch (err) {
        console.error("Google auth error:", err);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#F4F7FB]">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-2 border-[#1B4FD8] border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-sm text-[#0D1F3C]/60">Accesso con Google in corso...</p>
      </div>
    </div>
  );
}
